import { useMemo } from 'react';

import { SchoolConfigurationFragment, useCommunitiesQuery } from 'shared/graphql';

type Options = Parameters<typeof useCommunitiesQuery>[0];

/**
 * Hook for fetching communities.
 * @ticket https://github.com/jebelapp/jebel/issues/1562
 */
export function useCommunities(options?: Options) {
  const { data: response, loading } = useCommunitiesQuery(options);

  const communities: SchoolConfigurationFragment[] = useMemo(() => {
    return response?.communities?.items ?? [];
  }, [response]);

  return {
    data: communities,
    loading,
  };
}
